import { render, staticRenderFns } from "./OrderIdiomS.vue?vue&type=template&id=5399c9e6&scoped=true&"
import script from "./OrderIdiomS.vue?vue&type=script&lang=js&"
export * from "./OrderIdiomS.vue?vue&type=script&lang=js&"
import style0 from "./OrderIdiomS.vue?vue&type=style&index=0&id=5399c9e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5399c9e6",
  null
  
)

export default component.exports